import { Layouts } from '../../../../../controls/layouts';
import { Component, input, output } from '@angular/core';
import { LinkComponent } from 'src/app/controls/components/basic/link/link.component';

@Component({
  selector: 'app-group-box',
  standalone: true,
  imports: [Layouts, LinkComponent],
  templateUrl: './group-box.component.html',
  styleUrl: './group-box.component.scss'
})
export class GroupBoxComponent {

  disabled = input<boolean>(false);
  title = input.required<string>();
  required = input<boolean>(false);
  isValid = input<boolean>(true);
  validationText = input<string>('One or more required fields are missing or invalid.');
  editClicked = output<void>();
  supportsEdit = input<boolean>(false);

  onEditClicked() {
    if (this.supportsEdit()) {
      this.editClicked.emit();
    }
  }

}
